import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { BASE_URL } from "../App";
import { Circles } from 'react-loader-spinner'

import { UploadOutlined } from '@ant-design/icons';
import { Button as Btn, Card, Upload, message } from 'antd';

import { Backdrop, Button, CircularProgress, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

import LOGO from '../tormac.png';
import CustomTextField from "./Numerictext";
import { SelectNormal } from './SelectBox';

export default function ProDuctRegDetails() {
    const DATA = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [LocationDetails, setLocationDetails] = useState([]);
    const [InvImg, setInvImg] = useState([]);
    const [InstallStatus, setInstallStatus] = useState([]);
    const [value, setValue] = React.useState("");

    const [ItemDetails, setItemDetails] = useState({ Serial_No: '', Item_Name: '', Item_Description: '' });
    const [PersonalDetails, setPersonalDetails] = useState({ Name: '', Address: '', PinCode: '', State: '', District: '', Mobile_Number: '', Email: '' });
    const [ProductDetails, setProductDetails] = useState({ Purchase_Shop: '', Invoice_Number: '', Shop_Mobile_Number: '', Purchase_Place: '', Invoice_Date: '', Mechanic_Plumber_No: '', Mechanic_Plumber_Name: '' });

    const [UploadInvImg, setUploadInvImg] = useState([]);

    const SerialNo = DATA.state.Data.SerialNo;
    const ItemCode = DATA.state.Data.ItemCode;
    const ItemDescription = DATA.state.Data.ItemDescription;
    const Name = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.Name : null;
    const Address = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.Address : null;
    const DBPincode = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.Pincode : null;
    const District = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.District : null;
    const State = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.State : null;
    const MobileNo = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.MobileNo : null;
    const Email = DATA.state.Data.Persnol ? DATA.state.Data.Persnol.Email : null;
    const INVOICENO = DATA.state.Data.Product ? DATA.state.Data.Product.INVOICENO : null;
    const INVOICE_DATE = DATA.state.Data.Product ? DATA.state.Data.Product.INVOICE_DATE : null;
    const PURCHASED_PLACE = DATA.state.Data.Product ? DATA.state.Data.Product.PURCHASED_PLACE : null;
    const PURCHASED_FROM = DATA.state.Data.Product ? DATA.state.Data.Product.PURCHASED_FROM : null;
    const MECH_PLUMBER_NAME = DATA.state.Data.Product ? DATA.state.Data.Product.MECH_PLUMBER_NAME : null;
    const MECH_PLUMBER_MOBILE_NUMBER = DATA.state.Data.Product ? DATA.state.Data.Product.MECH_PLUMBER_MOBILE_NUMBER : null;
    const PURCHASED_SHOP_MOBILE_NUMBER = DATA.state.Data.Product ? DATA.state.Data.Product.PURCHASED_SHOP_MOBILE_NUMBER : null;

    useEffect(() => {
        InvImage();
    }, [])

    const InvImage = () => {
        setOpen(true);
        const data = { type: 'InvoiceImage', Serial_No: SerialNo, Item_Code: ItemCode }
        axios.post(BASE_URL + '/ProductRegister', data)
            .then(response => {
                setInvImg(response.data.message.inv_image);
                setInstallStatus(response.data.message.install_status);
            }).catch(error => {
                Swal.fire({
                    icon: "warning",
                    text: error.response.data.message
                });
            }).finally(() => {
                setOpen(false);
            });

    }

    const acceptedFileTypes = ['image/jpeg', 'image/png'];
    const InvoiceImage = {
        onRemove: (file) => {
            setUploadInvImg([]);
            const index = UploadInvImg.indexOf(file);
            const newFileList = UploadInvImg.slice();
            newFileList.splice(index, 1);
            setUploadInvImg(newFileList);
        },
        beforeUpload: (file) => {
            setUploadInvImg([]);
            const index = UploadInvImg.indexOf(file);
            const newFileList = UploadInvImg.slice();
            newFileList.splice(index, 1);
            setUploadInvImg(newFileList);

            const isAcceptedFileType = acceptedFileTypes.includes(file.type);
            if (!isAcceptedFileType) {
                message.error('You can only upload JPEG and PNG image files!');
            } else {
                setUploadInvImg([file]);
            }
            return false;
        },
        UploadInvImg,
    };

    const GetDistrictDetails = (pincode) => {
        if (pincode !== '') {
            setOpen(true);
            const data = { type: 'GetDistrict', PINCODE: pincode }
            axios.post(BASE_URL + '/ProductRegister', data)
                .then(response => {
                    setLocationDetails(response.data.message);
                }).catch(error => {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message
                    });
                }).finally(() => {
                    setOpen(false);
                });
        }
    }

    // const DISTRICT_LIST = LocationDetails ? LocationDetails.map((a) => ({
    //     Value: a.DISTRICT_CODE,
    //     Label: a.DISTRICT_NAME,
    // })) : [];

    // const STATE_LIST = LocationDetails ? LocationDetails.map((ste) => ({
    //     Value: ste.STATE_CODE,
    //     Label: ste.STATE,
    // })) : [];

    const DISTRICT_LIST = LocationDetails && LocationDetails.length > 0
        ? LocationDetails.map((a) => ({
            Value: a.DISTRICT_CODE,
            Label: a.DISTRICT_NAME,
        }))
        : [{ Value: '', Label: '' }];

    const STATE_LIST = LocationDetails && LocationDetails.length > 0
        ? LocationDetails.map((ste) => ({
            Value: ste.STATE_CODE,
            Label: ste.STATE,
        }))
        : [{ Value: '', Label: '' }];


    const handleSubmit = () => {
        setOpen(true);
        if (!ProductDetails.Invoice_Date) {
            Swal.fire({
                icon: "info",
                text: "Invoice Date Is Required!"
            });
            setOpen(false);
            return false;
        }

        if (!PersonalDetails.Name || !PersonalDetails.Address || !PersonalDetails.PinCode || !PersonalDetails.Mobile_Number || !ProductDetails.Purchase_Shop || !ProductDetails.Invoice_Number || !ProductDetails.Invoice_Date) {
            Swal.fire({
                icon: "info",
                text: "Fill All Required Fields!"
            });
            setOpen(false);
            return false;
        }

        const LOGIN_ID = localStorage.getItem('PROREG_USER_ID');
        const formData = new FormData();
        UploadInvImg.forEach((file) => {
            formData.append('image', file);
        });
        formData.append('Login_ID', LOGIN_ID);
        formData.append('installation', value);
        formData.append('type', 'ProRegInsert');
        formData.append('serialno', SerialNo);
        formData.append('customer_name', PersonalDetails.Name);
        formData.append('address', PersonalDetails.Address);
        formData.append('pincode', PersonalDetails.PinCode);
        formData.append('state', STATE_LIST[0].Value);
        formData.append('district', DISTRICT_LIST[0].Value);
        formData.append('mobile_no', PersonalDetails.Mobile_Number);
        formData.append('email', PersonalDetails.Email);
        formData.append('purchased_from', ProductDetails.Purchase_Shop);
        formData.append('purchased_shop_mob_no', ProductDetails.Shop_Mobile_Number);
        formData.append('purchased_place', ProductDetails.Purchase_Place);
        formData.append('invoice_no', ProductDetails.Invoice_Number);
        // formData.append('invoice_date', ProductDetails.Invoice_Date);
        formData.append('invoice_date', dayjs(ProductDetails.Invoice_Date).format('YYYY-MM-DD'),);
        formData.append('mech_plumber_name', ProductDetails.Mechanic_Plumber_Name);
        formData.append('mech_plumber_mob', ProductDetails.Mechanic_Plumber_No);
        axios.post(BASE_URL + '/ProductRegister', formData)
            .then(response => {
                // setLocationDetails(response.data.message);
                Swal.fire({
                    icon: "success",
                    text: response.data.message
                });
                navigate('/');
            }).catch(error => {
                Swal.fire({
                    icon: "warning",
                    text: error.response.data.message
                });
            }).finally(() => {
                setOpen(false);
            });
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div className="m-4">
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                {/* <CircularProgress color="inherit" /> */}
                <Circles height="80" width="80" color="rgba(255, 255, 255, 0.73)" />
            </Backdrop>
            <div style={{ float: 'left' }}>
                <img
                    alt="LOGO"
                    src={LOGO}
                    style={{ width: 100, height: 50 }}
                />
            </div>
            <center>
                <h3 style={{
                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: '1000',
                    textShadow: '1px 1px 1px #3fbb9c, 0px 3px 1px #000000',
                }}><i>Product Registration</i></h3>
            </center>
            <br />
            <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                <center><h5 style={{
                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: '1000',
                }}><u>Product Details</u></h5></center>
                <div className='row'>
                    <div className='col-md-4'>
                        <CustomTextField
                            label="Serial No"
                            name="Serial_No"
                            type="text"
                            size="small"
                            value={SerialNo}
                            onChange={(e) => setItemDetails({ ...ItemDetails, Serial_No: e.target.value })}
                            disabled={true}
                        />
                    </div>
                    <div className='col-md-4'>
                        <CustomTextField
                            label="Item Name"
                            name="Item_Name"
                            type="text"
                            size="small"
                            value={ItemCode ? ItemCode : '-'}
                            onChange={(e) => setItemDetails({ ...ItemDetails, Item_Name: e.target.value })}
                            disabled={true}
                        />
                    </div>
                    <div className='col-md-4'>
                        <CustomTextField
                            label="Item Description"
                            name="Item_Description"
                            type="text"
                            size="small"
                            value={ItemDescription ? ItemDescription : '-'}
                            onChange={(e) => setItemDetails({ ...ItemDetails, Item_Description: e.target.value })}
                            disabled={true}
                        />
                    </div>
                </div>
                {DATA.state.Data.Persnol && DATA.state.Data.Product ? (
                    <></>
                ) : (
                    <>
                        {InvImg === 'requierd' && (
                            <>
                                <hr />
                                <center><h5 style={{
                                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: '1000',
                                }}><u>Upload Invoice File</u></h5></center>
                                <div className='row'>
                                    <center>
                                        <div className='col-md-6'>
                                            <Upload {...InvoiceImage} maxCount={1}>
                                                <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Select File</Btn>
                                            </Upload>
                                            {/* <br />
                                            <Button
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                onClick={handleUpload}
                                                disabled={fileList.length === 0}
                                                loading={uploading}
                                            >
                                                <b>{uploading ? 'Uploading' : 'Start Upload'}</b>
                                            </Button> */}
                                        </div>
                                    </center>
                                </div>
                            </>
                        )}
                        {InstallStatus === 'required' && (
                            <>
                                <hr />
                                <center><h5 style={{
                                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: '1000',
                                }}><u>This Item is Eligible For Installation</u></h5></center>
                                <div className='row'>
                                    <center>
                                        <div className='col-md-6'>
                                            <b>Apply For Installation ?</b>
                                            <RadioGroup value={value} onChange={handleChange} row sx={{ justifyContent: 'center', textAlign: 'center' }}>
                                                <FormControlLabel value="YES" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="NO" control={<Radio />} label="No" />
                                            </RadioGroup>
                                        </div>
                                    </center>
                                </div>
                            </>
                        )}
                    </>
                )}
            </Card>
            <hr />
            <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                <center><h5 style={{
                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: '1000',
                }}><u>Personal Details</u></h5></center>
                <div className='row'>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Name "
                            name="Name"
                            size="small"
                            type="text"
                            required={true}
                            value={Name ? Name : PersonalDetails.Name}
                            disabled={DATA.state.Data.Persnol ? true : false}
                            onChange={(e) => {
                                const input = e.target.value;
                                const lettersOnly = input.replace(/[^A-Za-z, ]/ig, '');
                                setPersonalDetails({ ...PersonalDetails, Name: lettersOnly });
                            }}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label=" Address "
                            name=" Address"
                            size="small"
                            required={true}
                            value={Address ? Address : PersonalDetails.Address}
                            onChange={(e) => {
                                const input = e.target.value;
                                // const lettersOnly = input.replace(/[^A-Za-z,\D, ]/ig, '');
                                const truncatedInput = input.slice(0, 149);
                                setPersonalDetails({ ...PersonalDetails, Address: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Persnol ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="PinCode "
                            name="PinCode"
                            size="small"
                            required={true}
                            value={DBPincode ? DBPincode : PersonalDetails.PinCode}
                            onChange={(e) => {
                                const input = e.target.value;
                                const numbersOnly = input.replace(/\D/g, '');
                                const truncatedInput = numbersOnly.slice(0, 6);
                                setPersonalDetails({ ...PersonalDetails, PinCode: truncatedInput });
                            }}
                            onBlur={(e) => GetDistrictDetails(e.target.value)}
                            disabled={DATA.state.Data.Persnol ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        {District ? (
                            <CustomTextField
                                label="District"
                                name="District"
                                size="small"
                                required={true}
                                value={District}
                                onChange={(e) => setPersonalDetails({ ...PersonalDetails, District: e.target.value })}
                                disabled={DATA.state.Data.Persnol ? true : false}
                            />
                        ) : (
                            <SelectNormal
                                label="District"
                                name="District"
                                size="small"
                                options={DISTRICT_LIST}
                                value={District ? District : DISTRICT_LIST.length === 1 ? DISTRICT_LIST[0].Value : PersonalDetails.District}
                                onChange={(e) => {
                                    setPersonalDetails({ ...PersonalDetails, District: e.target.value })
                                }}
                                disabled={DATA.state.Data.Persnol ? true : false}
                                style={{
                                    height: "auto",
                                    width: "100%",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    transition: "all 0.3s ease-in-out",
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#00a8a2",
                                        },
                                    },
                                }}
                            />
                        )}
                    </div>
                    <div className='col-md-6'>
                        {District ? (
                            <CustomTextField
                                label="State"
                                name="State"
                                size="small"
                                required={true}
                                value={State}
                                onChange={(e) => setPersonalDetails({ ...PersonalDetails, State: e.target.value })}
                                disabled={DATA.state.Data.Persnol ? true : false}
                            />
                        ) : (
                            <SelectNormal
                                label="State"
                                name="State"
                                size="small"
                                options={STATE_LIST}
                                value={State ? State : STATE_LIST.length === 1 ? STATE_LIST[0].Value : PersonalDetails.State}
                                onChange={(e) => {
                                    setPersonalDetails({ ...PersonalDetails, State: e.target.value })
                                }}
                                disabled={DATA.state.Data.Persnol ? true : false}
                                style={{
                                    height: "auto",
                                    width: "100%",
                                    backgroundColor: "#f9f9f9",
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    transition: "all 0.3s ease-in-out",
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#00a8a2",
                                        },
                                    },
                                }}
                            />
                        )}
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Mobile Number "
                            name="Mobile_Number"
                            size="small"
                            required={true}
                            value={MobileNo ? MobileNo : PersonalDetails.Mobile_Number}
                            onChange={(e) => {
                                const input = e.target.value;
                                const numbersOnly = input.replace(/\D/g, '');
                                const truncatedInput = numbersOnly.slice(0, 10);
                                setPersonalDetails({ ...PersonalDetails, Mobile_Number: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Persnol ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Email"
                            name="Email"
                            size="small"
                            value={Email ? Email : PersonalDetails.Email}
                            onChange={(e) => setPersonalDetails({ ...PersonalDetails, Email: e.target.value })}
                            onBlur={(e) => {
                                const input = e.target.value;
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                const truncatedInput = emailRegex.slice(0, 40);
                                if (truncatedInput.test(input)) {
                                    setPersonalDetails({ ...PersonalDetails, Email: input });
                                } else {
                                    Swal.fire({
                                        icon: "info",
                                        text: "Not A Valid Email!"
                                    });
                                }
                            }}
                            disabled={DATA.state.Data.Persnol ? true : false}
                        />
                    </div>
                </div>
            </Card>
            <hr />
            <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                <center><h5 style={{
                    background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: '1000',
                }}><u>Purchase Details</u></h5></center>
                <div className='row'>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Purchase Shop From "
                            name="Purchase_Shop"
                            size="small"
                            required={true}
                            value={PURCHASED_FROM ? PURCHASED_FROM : ProductDetails.Purchase_Shop}
                            onChange={(e) => {
                                const input = e.target.value;
                                // const lettersOnly = input.replace(/[^A-Za-z, ]/ig, '');
                                const truncatedInput = input.slice(0, 59);
                                setProductDetails({ ...ProductDetails, Purchase_Shop: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Invoice Number "
                            name="Invoice_Number"
                            size="small"
                            required={true}
                            value={INVOICENO ? INVOICENO : ProductDetails.Invoice_Number}
                            onChange={(e) => {
                                const input = e.target.value;
                                const truncatedInput = input.slice(0, 90);
                                setProductDetails({ ...ProductDetails, Invoice_Number: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Purchase Shop Mobile Number"
                            name="Shop_Mobile_Number"
                            size="small"
                            value={PURCHASED_SHOP_MOBILE_NUMBER ? PURCHASED_SHOP_MOBILE_NUMBER : ProductDetails.Shop_Mobile_Number}
                            onChange={(e) => {
                                const input = e.target.value;
                                const numbersOnly = input.replace(/\D/g, '');
                                const truncatedInput = numbersOnly.slice(0, 10);
                                setProductDetails({ ...ProductDetails, Shop_Mobile_Number: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Purchase Place"
                            name="Purchase_Place"
                            size="small"
                            value={PURCHASED_PLACE ? PURCHASED_PLACE : ProductDetails.Purchase_Place}
                            onChange={(e) => {
                                const input = e.target.value;
                                // const lettersOnly = input.replace(/[^A-Za-z, ]/ig, '');
                                const truncatedInput = input.slice(0, 39);
                                setProductDetails({ ...ProductDetails, Purchase_Place: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Mechanic/Plumber Mobile Number"
                            name="Mechanic_Plumber_No"
                            size="small"
                            value={MECH_PLUMBER_MOBILE_NUMBER ? MECH_PLUMBER_MOBILE_NUMBER : ProductDetails.Mechanic_Plumber_No}
                            onChange={(e) => {
                                const input = e.target.value;
                                const numbersOnly = input.replace(/\D/g, '');
                                const truncatedInput = numbersOnly.slice(0, 10);
                                setProductDetails({ ...ProductDetails, Mechanic_Plumber_No: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6'>
                        <CustomTextField
                            label="Mechanic/Plumber Name"
                            name="Mechanic_Plumber_Name"
                            size="small"
                            value={MECH_PLUMBER_NAME ? MECH_PLUMBER_NAME : ProductDetails.Mechanic_Plumber_Name}
                            onChange={(e) => {
                                const input = e.target.value;
                                const lettersOnly = input.replace(/[^A-Za-z, ]/ig, '');
                                const truncatedInput = lettersOnly.slice(0, 50);
                                setProductDetails({ ...ProductDetails, Mechanic_Plumber_Name: truncatedInput });
                            }}
                            disabled={DATA.state.Data.Product ? true : false}
                        />
                    </div>
                    <div className='col-md-6 mt-2'>
                        {INVOICE_DATE ? (
                            <CustomTextField
                                label="Invoice Date "
                                name="Invoice_Date"
                                size="small"
                                required={true}
                                value={INVOICE_DATE}
                                onChange={(e) => setProductDetails({ ...ProductDetails, Invoice_Date: e.target.value })}
                                disabled={DATA.state.Data.Product ? true : false}
                            />
                        ) : (
                            <>
                                {/* <label><b>Invoice Date <span className='text-danger'>*</span></b></label>
                                {/* <DatePicker
                                    inputPrefixCls="custom-datepicker"
                                    suffixIcon={<span style={{ color: 'red' }}>📅</span>}
                                    className="mt-3"
                                    // placeholder="Invoice Date *"
                                    // label="Invoice Date"
                                    name="Invoice_Date"
                                    size="large"
                                    onChange={(date) => { setProductDetails({ ...ProductDetails, Invoice_Date: date }); }}
                                    style={{ width: '100%', padding: '9px', color: 'black' }}
                                /> */}
                                <DemoItem>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <MobileDatePicker
                                            label={<b>Invoice Date <span className='text-danger'>*</span></b>}
                                            name="Invoice_Date"
                                            size="small"
                                            onChange={(date) => { setProductDetails({ ...ProductDetails, Invoice_Date: date }); }}
                                            maxDate={dayjs()}
                                            style={{
                                                height: "auto",
                                                width: "100%",
                                                backgroundColor: "#f9f9f9",
                                                borderRadius: "8px",
                                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                                transition: "all 0.3s ease-in-out",
                                            }}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#00a8a2",
                                                    },
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </DemoItem>
                            </>
                        )}
                    </div>
                </div>
            </Card>
            <>
                {DATA.state.Data.Persnol && DATA.state.Data.Product ? (
                    <>
                        <hr />
                        <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                            <div className='row'>
                                <div className='col'>
                                    <center><h5 style={{
                                        background: 'linear-gradient(117deg, rgb(0, 168, 162) 20%, rgb(0, 168, 162) 80%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: '1000',
                                        textShadow: '1px 1px 1px #3fbb9c, 0px 3px 1px #000000',
                                    }}><u>
                                            Product Already Registered !
                                        </u></h5></center>
                                    {/* <b className="text-primary"><center></center></b> */}
                                </div>
                            </div>
                        </Card>
                    </>
                ) : (
                    <>
                        <hr />
                        <Card className="rounded" style={{ padding: '10px', boxShadow: '2px 4px 8px rgba(0, 168, 162, 1), inset 1px 2px 8px rgba(0, 168, 162, 1)', border: '1px solid #00a8a2' }}>
                            <div className='row'>
                                <div className='col'>
                                    <Button onClick={handleSubmit} variant="contained" fullWidth style={{ background: 'linear-gradient(117deg, rgb(0 213 200) 20%, rgb(0, 168, 162) 80%)' }} ><b>Register</b></Button>
                                </div>
                            </div>
                        </Card>
                    </>
                )}
            </>
        </div >
    );
};